<template>
  <div>
    <div @mousemove="move" class="w3l-banner">
      <div :style="
        'transform: translate(' +
        (position == 'left' ? '20' : '-20') +
        'px,' +
        (position2 == 'top' ? '10' : '-10') +
        'px) scale(1.1)'
      " class="banner-image"></div>
      <div class="titleBox" :class="contType == 'e' ? 'titleBoxe' : ''">
        <div class="wow flipInX titleT1" :class="contType == 'e' ? 'titleT1e' : ''">{{ contType == 'e' ? contList.title1[contType] + '\n' + contList.title2[contType] : contList.title1[contType] + '\n' + contList.title2[contType] }}</div>
        <div class="wow flipInX " :class="contType == 'e' ? 'titleT1pe' : 'titleT1p'">{{ contType == 'e' ? contList.title1[contType] + contList.title2[contType] : contList.title1[contType] + '\n' + contList.title2[contType] }}</div>
        <div class="wow flipInX titleT2"  :class="contType == 'e' ? 'titleT2e' : ''">{{ contList.title3[contType] }}</div>
        <!-- <div class="experience">{{ contList.titleBtn[contType] }}</div> -->
        <img class="wow bounceInRight topImgBg" src="../assets/img/ProductService/icon_top_bg_101.svg" alt="" />
        <img class="wow bounceInUp titlebg" src="../assets/img/ProductService/icon_tpo103.svg" alt="" />
        <img class="wow bounceInDown titlebgIcon3" src="../assets/img/ProductService/icon_top_104.svg" alt="" />
      </div>
    </div>

    <div class="contBox">
      <div class="wow bounceInUp generalTitle mt100">
        {{ contList.general1T1[contType] }}
      </div>
      <div class="wow bounceInUp generalTitle2" data-wow-delay="0.2s">
        {{ contList.general1T2[contType] }}
      </div>
      <div v-if="contType != 'e'" class="wow bounceInUp generalTitle2 mb60" data-wow-delay="0.3s">
        {{ contList.general1T3[contType] }}
      </div>
      <div v-if="contType == 'e'" class="wow bounceInUp generalTitle2e" data-wow-delay="0.3s">
        {{ contList.general1T3[contType][0] }}
      </div>
      <div v-if="contType == 'e'" class="wow bounceInUp generalTitle2e mb60" data-wow-delay="0.3s">
        {{ contList.general1T3[contType][1] }}
      </div>
      <div class="wow bounceInUp generalTitle3" data-wow-delay="0.2s">
        {{ contList.general1T2[contType] }}{{ contList.general1T3[contType][0] }}{{ contList.general1T3[contType][1] }}
      </div>
      <div class="programme">
        <div class="wow bounceInUp programmeBox" :class="[hoverType[0] == 1 ? 'programmeBox1' : '']"
          @mouseenter="handleMouseEnter('0')" @mouseleave="handleMouseLeave('0')">
          <img v-if="hoverType[0] == 0" class="programmeIcon" src="../assets/img/ProductService/icon_961.svg" alt="" />
          <img v-if="hoverType[0] == 1" class="programmeIcon" src="../assets/img/ProductService/icon_1573.svg" alt="" />
          <div class="programmeT1" :class="[hoverType[0] == 1 ? 'programmeT11' : '']">{{
            contList.programmeB1T1[contType]
          }}</div>
          <div class="programmeT2" :class="[hoverType[0] == 1 ? 'programmeT21' : '']">{{
            contList.programmeB1T2[contType]
          }}</div>
        </div>
        <div class="wow bounceInUp programmeBox" :class="[hoverType[1] == 1 ? 'programmeBox1' : '']"
          @mouseenter="handleMouseEnter('1')" @mouseleave="handleMouseLeave('1')">
          <img v-if="hoverType[1] == 0" class="programmeIcon" src="../assets/img/ProductService/icon_962.png" alt="" />
          <img v-if="hoverType[1] == 1" class="programmeIcon" src="../assets/img/ProductService/icon_1574.svg" alt="" />
          <div class="programmeT1" :class="[hoverType[1] == 1 ? 'programmeT11' : '']">{{
            contList.programmeB2T1[contType]
          }}</div>
          <div class="programmeT2" :class="[hoverType[1] == 1 ? 'programmeT21' : '']">{{
            contList.programmeB2T2[contType]
          }}</div>
        </div>
        <div class="wow bounceInUp programmeBox" :class="[hoverType[2] == 1 ? 'programmeBox1' : '']"
          @mouseenter="handleMouseEnter('2')" @mouseleave="handleMouseLeave('2')">
          <img v-if="hoverType[2] == 0" class="programmeIcon" src="../assets/img/ProductService/icon_963.png" alt="" />
          <img v-if="hoverType[2] == 1" class="programmeIcon" src="../assets/img/ProductService/icon_1575.svg" alt="" />
          <div class="programmeT1" :class="[hoverType[2] == 1 ? 'programmeT11' : '']">{{
            contList.programmeB3T1[contType]
          }}</div>
          <div class="programmeT2" :class="[hoverType[2] == 1 ? 'programmeT21' : '']">{{
            contList.programmeB3T2[contType]
          }}</div>
        </div>
      </div>
    </div>

    <div class="bgBox">
      <img class="bg1" src="../assets/img/ProductService/icon_two_section_1267@2x.png" alt="">
    </div>
    <div class="contBox padt50">
      <img class="bg11" src="../assets/img/ProductService/bg11.png" alt="">
      <div class="wow bounceInUp generalTitle mt200 mgt0" data-wow-duration="1s">
        {{ contList.sectionTwoA1[contType] }}
      </div>
      <div class="wow bounceInUp generalTitle2" data-wow-duration="1s">
        {{ contList.sectionTwoA2[contType] }}
      </div>
      <div class="wow bounceInUp generalTitle2" data-wow-duration="1s">
        {{ contList.sectionTwoA3[contType] }}
      </div>
      <div class="wow bounceInUp generalTitle2 mb60" data-wow-duration="1s">
        {{ contList.sectionTwoA4[contType] }}
      </div>
      <div class="wow bounceInUp generalTitle4" data-wow-duration="1s">
        {{ contList.sectionTwoA2[contType] }}{{ contList.sectionTwoA3[contType] }}{{ contList.sectionTwoA4[contType] }}
      </div>
      <div class="programmeBim">
        <div class="wow bounceInUp IBANBox" data-wow-delay="0.1s">
          <img class="IBANIcon" src="../assets/img/ProductService/icon_two_section_101.svg" alt="" />
          <div class="programmeT1">
            {{ contList.sectionTwoA[contType][0] }}
          </div>
          <div class="IBANT2">
            {{ contList.sectionTwoA[contType][1] }}
          </div>
        </div>
        <div class="wow bounceInUp IBANBox" data-wow-delay="0.2s">
          <img class="IBANIcon" src="../assets/img/ProductService/icon_two_section_102.png" alt="" />
          <div class="programmeT1">
            {{ contList.sectionTwoA[contType][2] }}
          </div>
          <div class="IBANT2">
            {{ contList.sectionTwoA[contType][3] }}
          </div>
        </div>
        <div class="wow bounceInUp IBANBox" data-wow-delay="0.3s">
          <img class="IBANIcon" src="../assets/img/ProductService/icon_two_section_103.png" alt="" />
          <div class="programmeT1">
            {{ contList.sectionTwoA[contType][4] }}
          </div>
          <div class="IBANT2">
            {{ contList.sectionTwoA[contType][5] }}
          </div>
        </div>
      </div>
      <div class="wow bounceInUp bimPhone">
        <Swiper :options="swiperOption" ref="mySwiper" class="sw" @ready="onSwiper"
    @slideChange="onSlideChange">
          <Swiper-Slide style="width: 245px;;margin-right: 16px;">
            <div class="IBANBox" :class="contType == 'e' ? 'IBANBoxe' : ''">
              <img class="IBANIcon" src="../assets/img/ProductService/icon_two_section_101.svg" alt="" />
              <div class="programmeT1">
                {{ contList.sectionTwoA[contType][0] }}
              </div>
              <div class="IBANT2">
                {{ contList.sectionTwoA[contType][1] }}
              </div>
            </div>
          </Swiper-Slide>

          <Swiper-Slide style="width: 245px;">
            <div class="IBANBox" :class="contType == 'e' ? 'IBANBoxe' : ''">
              <img class="IBANIcon" src="../assets/img/ProductService/icon_two_section_102.png" alt="" />
              <div class="programmeT1">
                {{ contList.sectionTwoA[contType][2] }}
              </div>
              <div class="IBANT2">
                {{ contList.sectionTwoA[contType][3] }}
              </div>
            </div>
          </Swiper-Slide>

          <Swiper-Slide style="width: 245px;margin-right: 16px;">
            <div class="IBANBox" :class="contType == 'e' ? 'IBANBoxe' : ''">
              <img class="IBANIcon" src="../assets/img/ProductService/icon_two_section_103.png" alt="" />
              <div class="programmeT1">
                {{ contList.sectionTwoA[contType][4] }}
              </div>
              <div class="IBANT2">
                {{ contList.sectionTwoA[contType][5] }}
              </div>
            </div>
          </Swiper-Slide>
        </Swiper>
        <div class="wow bounceInUp pagination">
          <div class="point" :class="[curIndex == 0 ? 'point_s' : '']" @click="clickChangePage(0)"></div>
          <div class="point mgLR" :class="[curIndex == 1 ? 'point_s' : '']" @click="clickChangePage(1)"></div>
          <div class="point" :class="[curIndex == 2 ? 'point_s' : '']" @click="clickChangePage(2)"></div>
        </div>
      </div>
    </div>


    <div class="contBox">
      <div class="wow bounceInUp generalTitle mt235" data-wow-duration="1s">
        {{ contList.sectionTwoA5[contType][0] }}
      </div>
      <div class="wow bounceInUp generalTitle2 sectionTwoA5E" data-wow-duration="1s">
        {{ contList.sectionTwoA5[contType][1] }}
      </div>
      <div class="wow bounceInUp generalTitle2 mb60" data-wow-duration="1s">
        {{ contList.sectionTwoA5[contType][8] }}
      </div>
      <div class="wow bounceInUp generalTitle4" data-wow-duration="1s">
        {{ contList.sectionTwoA5[contType][1] }} {{ contList.sectionTwoA5[contType][8] }} {{ contList.sectionTwoA5[contType][8] }}
      </div>
      <div class="programme">
        <div class="wow bounceInUp programmeBox" :class="[hoverType[3] == 1 ? 'programmeBox1' : '']"
          @mouseenter="handleMouseEnter('3')" @mouseleave="handleMouseLeave('3')">
          <img v-if="hoverType[3] == 0" class="programmeIcon" src="../assets/img/ProductService/icon_1225.svg" alt="" />
          <img v-if="hoverType[3] == 1" class="programmeIcon" src="../assets/img/ProductService/icon_1222.svg" alt="" />
          <div class="programmeT1" :class="[hoverType[3] == 1 ? 'programmeT11' : '']">{{
            contList.sectionTwoA5[contType][2]
          }}</div>
          <div class="programmeT2" :class="[hoverType[3] == 1 ? 'programmeT21' : '']">{{
            contList.sectionTwoA5[contType][3]
          }}</div>
        </div>
        <div class="wow bounceInUp programmeBox" :class="[hoverType[4] == 1 ? 'programmeBox1' : '']"
          @mouseenter="handleMouseEnter('4')" @mouseleave="handleMouseLeave('4')">
          <img v-if="hoverType[4] == 0" class="programmeIcon" src="../assets/img/ProductService/icon_1226.svg" alt="" />
          <img v-if="hoverType[4] == 1" class="programmeIcon" src="../assets/img/ProductService/icon_1223.svg" alt="" />
          <div class="programmeT1" :class="[hoverType[4] == 1 ? 'programmeT11' : '']">{{
            contList.sectionTwoA5[contType][4]
          }}</div>
          <div class="programmeT2" :class="[hoverType[4] == 1 ? 'programmeT21' : '']">{{
            contList.sectionTwoA5[contType][5]
          }}</div>
        </div>
        <div class="wow bounceInUp programmeBox" :class="[hoverType[5] == 1 ? 'programmeBox1' : '']"
          @mouseenter="handleMouseEnter('5')" @mouseleave="handleMouseLeave('5')">
          <img v-if="hoverType[5] == 0" class="programmeIcon" src="../assets/img/ProductService/icon_1227.svg" alt="" />
          <img v-if="hoverType[5] == 1" class="programmeIcon" src="../assets/img/ProductService/icon_1224.svg" alt="" />
          <div class="programmeT1" :class="[hoverType[5] == 1 ? 'programmeT11' : '']">{{
            contList.sectionTwoA5[contType][6]
          }}</div>
          <div class="programmeT2" :class="[hoverType[5] == 1 ? 'programmeT21' : '']">{{
            contList.sectionTwoA5[contType][7]
          }}</div>
        </div>
      </div>
    </div>

    <div class="bgBox">
      <div class="bgColor"></div>
      <img class="bge" src="../assets/img/ProductService/icon_esec.svg" alt="">
    </div>
    <div class="contBox">
      <div class="qbBox">
        <img class="wow bounceInUp qbBg" src="../assets/img/ProductService/qb_bg.svg" alt="">
        <img v-if="contType != 'e'" class="bge1" src="../assets/img/ProductService/bg1577.png" alt="">
        <img v-if="contType == 'e'" class="wow bounceInUp qbBge" src="../assets/img/ProductService/qb_bge.png" alt="">
        <img class="wow bounceInUp qbMobile" :class="contType == 'e' ? 'qbMobilee' : ''" src="../assets/img/ProductService/qb_mobile.png" alt=""
          data-wow-delay="0.5s">
        <div class="qbTextBox">
          <div class="wow bounceInUp qbTitle" :class="contType == 'e' ? 'qbTitlee' : ''" data-wow-delay="0.5s">{{ contList.sectionTwoA6[contType][0] }}</div>
          <div class="wow bounceInUp" :class="contType == 'e' ? 'qbTitle11' : 'qbTitle1'" data-wow-delay="0.5s">{{ contList.sectionTwoA6[contType][1] }}</div>
          <div class="wow bounceInUp" :class="contType == 'e' ? 'qbTitle11' : 'qbTitle1'" data-wow-delay="0.5s">{{ contList.sectionTwoA6[contType][2] }}</div>
          <div class="wow bounceInUp" :class="contType == 'e' ? 'qbTitle11' : 'qbTitle1'" data-wow-delay="0.5s">{{ contList.sectionTwoA6[contType][3] }}</div>
        </div>
      </div>
    </div>


    <div class="bgBox hide">
      <img class="bgLB" src="../assets/img/ProductService/icon_lb.svg" alt="">
      <img class="bgTR" src="../assets/img/ProductService/icon_tr.svg" alt="">
    </div>
    <div class="contBox">
      <div class="wow bounceInUp generalTitle mt200" data-wow-duration="1s">
        {{ contList.sectionTwoA7[contType][0] }}
      </div>
      <div class="wow bounceInUp generalTitle2 mb60 sectionTwoA7e" style="white-space: pre-wrap;" data-wow-duration="1s">
        {{ contList.sectionTwoA7[contType][1] }}
      </div>
      <div class="wow bounceInUp generalTitle4 mat20" data-wow-duration="1s">
        {{ contList.sectionTwoA7[contType][1] }}
      </div>
      

      <div class="cardBoxL" style="margin-bottom: 50px;">
        <img class="wow bounceInUp cardImg" style="margin-right: 33px;" src="../assets/img/ProductService/card_1.png"
          alt="">
        <div class="cardBoxR">
          <div class="wow bounceInUp cardBoxRT">{{ contList.sectionTwoA7[contType][2] }}</div>
          <div class="wow bounceInUp cardBoxRT1">{{ contList.sectionTwoA7[contType][3] }}</div>
          <img class="wow bounceInUp cardBoxRTIcon" src="../assets/img/ProductService/qb_r.svg" alt="">
        </div>
      </div>
      <div class="cardBoxL" style="justify-content: space-between;margin-bottom: 100px;">
        <img class="wow bounceInUp cardImg2" src="../assets/img/ProductService/card_2.png" alt="">
        <div class="cardBoxR">
          <div class="wow bounceInUp cardBoxRT">{{ contList.sectionTwoA7[contType][4] }}</div>
          <div class="wow bounceInUp cardBoxRT1 mat50">{{ contList.sectionTwoA7[contType][5] }}</div>
          <img class="wow bounceInUp cardBoxRTIcon" src="../assets/img/ProductService/qb_r.svg" alt="">
        </div>
        <img class="wow bounceInUp cardImg1 hide" src="../assets/img/ProductService/card_2.png" alt="">
      </div>
    </div>

  </div>
</template>

<script>
import M from "minimatch";
import { WOW } from "wowjs";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import { Autoplay } from 'swiper'

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  name: "index",
  data: (vm) => {
    return {
      bodyW: 0,
      bodyY: 0,
      position: "",
      position2: "",
      contList: {
        title1: {
          z: "全球化收付产品",
          f: "全球化收付產品",
          e: "Global Collection/Payment",
        },
        title2: {
          z: "本地化服务",
          f: "本地化服務",
          e:' Localized Services'
        },
        title3: {
          z: "近百家国际金融合作伙伴，支持150+国家与地区；\n服务本地化、个性化",
          f: "近百家國際金融合作夥伴，支持150+國家與地區；\n服務本地化、個性化",
          e:'Nearly 100 international financial partners support transactions in more than 150 countries and regions; Service localization and personalization.'
        },
        titleBtn: {
          z: "立即体验",
          f: "立即體驗",
          e: "立即体验",
        },
        general1T1: {
          z: "跨境收单业务",
          f: "跨境收單業務",
          e:'Cross-border Merchant services'
        },
        general1T2: {
          z: "一次集成即可触及全球，为跨境贸易企业提供聚合支付网关，",
          f: "一次集成即可觸及全球，為跨境貿易企業提供聚合支付網關，",
          e:'Suntone provides an aggregated payment gateway for enterprises engaging in cross-border trades, '
        },
        general1T3: {
          z: "支持Visa/ Mastercard/Unionpay等全球主流国际信用卡、海外本土移动支付工具等多元化支付方式。",
          f: "支持Visa/ Mastercard/Unionpay等全球主流國際信用卡、海外本土移動支付工具等多元化支付方式。",
          e:['supporting diversified payment methods such as Visa/ MasterCard/UnionPay and ','other mainstream international credit cards as well as overseas local mobile payment tools.']
        },

        programmeB1T1: {
          z: "灵活的对接方式",
          f: "靈活的對接方式",
          e:'Flexible Connection Mode'
        },
        programmeB1T2: {
          z: "支持Shopify, Woocommerce, Magento 等主流建站平台插件对接，立即为网站实现顺畅付款体验。更有API对接，核心组件等灵活的对接方案。",
          f: "支持Shopify, Woocommerce, Magento 等主流建站平臺插件對接，立即為網站實現順暢付款體驗。更有API對接，核心組件等靈活的對接方案。",
          e:'Suntone supports connection with Shopify, Woocommerce, Magento and other mainstream SaaS platforms, enables instant and smooth payment experience for the website. Moreover, API connection, core components and other flexible connection schemes are available.'
        },
        programmeB2T1: {
          z: "稳定的交易系统",
          f: "穩定的交易系統",
          e:'Stable Transaction System'
        },
        programmeB2T2: {
          z: "高效平稳的交易系统，即时交易秒级处理，支付成功率领先于同业产品。",
          f: "高效平穩的交易系統，即時交易秒級處理，支付成功率領先於同業產品。",
          e:'With efficient and stable transaction system and instant transaction processed in seconds, payment success rates lead the interbank products.'
        },
        programmeB3T1: {
          z: "自主研发的商户交易管理平台",
          f: "自主研發的商戶交易管理平臺",
          e:'Independently Developed Merchant Transaction Management Platform'
        },
        programmeB3T2: {
          z: "跨境资金管理平台，为你带来功能强大、个性化的跨境资金管理体验。",
          f: "跨境資金管理平臺，為你帶來功能強大、個性化的跨境資金管理體驗。",
          e:'The cross-border fund management platform brings you powerful and personalized cross-border fund management experience.'
        },
        sectionTwoA1: {
          z: "欧洲IBAN开户",
          f: "歐洲IBAN開戶",
          e:'Opening Accounts with European IBAN'
        },
        sectionTwoA2: {
          z: "为满足跨境电商的本地化需求，积极帮助客户提高核心竞争力，",
          f: "爲滿足跨境電商的本地化需求，積極幫助客戶提高核心競爭力，",
          e:'In order to meet the localization needs of cross-border merchant, we actively help customers improve their core competitiveness,'
        },
        sectionTwoA3: {
          z: "推出欧洲IBAN账户产品，实现美元、欧元、英镑、多币种IBAN账户远程开户，",
          f: "推出歐洲IBAN賬戶産品，實現美元、歐元、英鎊、多幣種IBAN賬戶遠程開戶，",
          e:'launch European IBAN account products, realize remote opening of IBAN accounts in US Dollars, Euro, Pound Sterling and multiple currencies, '
        },
        sectionTwoA4: {
          z: "支持实时低成本货币兑换，全力打造一站式跨境支付解决方案和服务。",
          f: "支持實時低成本貨幣兌換，全力打造一站式跨境支付解決方案和服務。",
          e:'support real-time low-cost currency exchange, and strive to create one-stop cross-border payment solutions and services.'
        },
        sectionTwoA: {
          z: [
            "快捷开户",
            "告别繁琐的传统银行开户流程，仅需几分钟即可快速开设多币种收款账号并开始使用。",
            "收付一体",
            "多币种收款账户直连换汇与国际付款，增强资金周转效率。",
            "成本优化",
            "远优于行业水平的优惠费率，并提供高竞争力的实时汇率，为企业显著降低收、付款成本。"
          ],
          f: [
            "快捷開戶",
            "告別繁瑣的傳統銀行開戶流程，僅需幾分鐘即可快速開設多幣種收款賬號並開始使用。",
            "收付一體",
            "多幣種收款賬戶直連換匯與國際付款，增強資金週轉效率。",
            "成本優化",
            "遠優於行業水平的優惠費率，並提供高競爭力的實時匯率，爲企業顯著降低收、付款成本。"
          ],
          e: [
            "Quick Account Opening",
            "Bidding farewell to the tedious traditional bank account opening process, it only takes a few minutes to quickly open a multi-currency collection account and start using it.",
            "Integrated Collection/Payment",
            "Multi-currency collection accounts are directly linked to exchange and international payment, enhancing the efficiency of capital turnover.",
            "Cost Optimization",
            "It offers a preferential rate far superior to the industry level, provides a highly competitive real- time exchange rate, significantly reducing the cost of collection and payment for enterprises."
          ]
        },
        sectionTwoA5: {
          z: [
            "资金汇兑",
            "为跨境企业提供便捷的资金汇兑平台，与多家银行合作，满足用户贸易汇款及清算需求，实时汇款，",
            "快速到账",
            "直连高时效的全球本地清算系统，以媲美本地支付的效率处理跨境交易，提高付款时效。",
            "更优成本",
            "减少对中间行跨境支付网络的依赖，进而降低手续费，实现低成本、全额到账。",
            "操作高效",
            "高效平稳的交易系统，即时交易秒级处理，支付成功率领先于同业产品。",
            "快速到账，支持多币种，安全可靠，让您省心放心。"
          ],
          f: [
            "資金匯兌",
            "爲跨境企業提供便捷的資金匯兌平颱，與多家銀行合作，滿足用戶貿易匯款及清算需求，實時匯款，",
            "快速到賬",
            "直連高時效的全球本地清算繫統，以媲美本地支付的效率處理跨境交易，提高付款時效。",
            "更優成本",
            "減少對中間行跨境支付網絡的依賴，進而降低手續費，實現低成本、全額到賬。",
            "操作高效",
            "高效平穩的交易繫統，即時交易秒級處理，支付成功率領先於同業産品。",
            "快速到賬，支持多幣種，安全可靠，讓您省心放心。"
          ],
          e: [
            "Exchange of Funds",
            "It provides a convenient fund exchange platform for cross-border enterprises, cooperates with a number of banks to meet the needs of users' trade remittances and clearing, real-time remittances, fast arrival of funds, and supports safe and reliable multi-currency transactions, so that you can rest assured.",
            "Fast Payment",
            "Direct and efficient connection to the local clearing systems worldwide, it can process cross-border transactions as efficiently as local payment and improve payment timeliness.",
            "Better Cost",
            "Relies less on the intermediary cross-border payment network, thereby reducing handling fees of customers，and achieving full payment at low cost.",
            "Efficient Operation",
            "Suntone supports payment to the payees in batch through the web client, or implements comprehensive payment automation through the API, and process thousands of transactions in seconds."
          ]
        },
        sectionTwoA6: {
          z: [
            "电子钱包",
            "• 支持所有产品形态接入支付，包括APP、PC网页及H5，通过API可实现在任何平台和场景下接入支付功能。",
            "• 快捷接入，安全高效，支持多重收款渠道，灵活满足客户的多样化需求。持有国际认证证书，以及由当地金融机构颁发的金融服务牌照。 ",
            "• 为多家知名跨境电商、跨境医疗、跨境教育、跨境旅游、海外线下零售等提供专业解决方案，覆盖全球多个地区。",
          ],
          f: [
            "電子錢包",
            "• 支持所有産品形態接入支付，包括APP、PC網頁及H5，通過API可實現在任何平颱和場景下接入支付功能。",
            "• 快捷接入，安全高效，支持多重收款渠道，靈活滿足客戶的多樣化需求。持有國際認証証書，以及由當地金融機構頒髮的金融服務牌照。 ",
            "• 爲多家知名跨境電商、跨境醫療、跨境教育、跨境旅遊、海外線下零售等提供專業解決方案，覆蓋全球多個地區。",
          ],
          e: [
            "E-Wallet",
            "• Suntone supports payment access in all product forms, including APP, PC web page and H5, and can access payment functionality in any platform and scenario through the API.",
            "• With fast access, secure and efficient systems, and multiple collection channels to meet diverse needs.\nSuntone holds license for international certification and financial services issued by local financial institutions.",
            "• With professional solutions for many well-known cross-border e-commerce, cross-border medical care, cross-border education, cross-border tourism, and overseas offline retails, Our services covering many regions around the world.",
          ]
        },
        sectionTwoA7: {
          z: [
            "预付卡/虚拟卡",
            "通过预付卡APP数字钱包轻松进行预付费卡管理，专业化处理付款数据和充值预付卡，开发联合品牌产品，定制完全客制化方案。\n为财务、管理者、预算持有者定制不同权限，为相关用户提供信息透明性，助力团队高效协作。",
            "交易实时回顾",
            "提供用于安全交换数据的数据传输管理系统，系統交易记录、卡片余额即时查看，让管理者和运营者实时观测支出情况。",
            "灵活账单周期",
            "支持下载自定义周期的交易记录，灵活配合财务对账周期，财务周期不再受限于信用卡账单。",
          ],
          f: [
            "預付卡/虛擬卡",
            "通過預付卡APP數字錢包輕鬆進行預付費卡管理，專業化處理付款數據和充值預付卡，開髮聯合品牌産品，定製完全客製化方案。\n爲財務、管理者、預算持有者定製不同權限，爲相關用戶提供信息透明性，助力團隊高效協作。",
            "交易實時回顧",
            "提供用於安全交換數據的數據傳輸管理繫統，繫統交易記錄、卡片餘額即時查看，讓管理者和運營者實時觀測支出情況。",
            "靈活賬單週期",
            "支持下載自定義週期的交易記錄，靈活配合財務對賬週期，財務週期不再受限於信用卡賬單。",
          ],
          e: [
            "Prepaid Cards/Virtual Cards",
            "Through the prepay card APP digital wallet, it is easy to manage prepaid cards, professionally process payment data and recharge prepay cards, develop co-branded products, and customize fully customized solutions. We customize different permissions for financiers, managers, and budget holders to provide information transparency for relevant users and help teams collaborate efficiently.",
            "Real-time Review of Transactions",
            "Suntone makes available a data transfer management system for secure exchange of data, system transaction records, and real-time view of card balance, allowing managers and operators to observe the expenditure in real time.",
            "Flexible Bill Period",
            "Suntone supports downloading transaction records of a user-defined period, flexible coordination with financial reconciliation cycle, and financial cycle is no longer limited by credit card bills.",
          ]
        },
      },
      contType: "z",
      hoverType: {
        '0': 0,
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
      },
      curIndex: 0,
      swiperOption: {
        // swiper options 所有的配置同swiper官方api配置
        autoplay:{
          delay: 5000,
          disableOnInteraction: true,
        },   // 自动播放的时间间隔
        slidesPerView: 1.4,  //一次显示的数量
        direction: "horizontal", // 水平轮播,
        spaceBetween: 16,
        modules:[Autoplay],
      },
      swiper: null
    };
  },
  methods: {
    move(e) {
      if (e.pageX > this.bodyW / 2) {
        this.position = "right";
      } else {
        this.position = "left";
      }
      if (e.pageY > 425) {
        this.position2 = "top";
      } else {
        this.position2 = "bottom";
      }
    },
    handleMouseEnter(item) {
      this.hoverType[item] = 1
    },
    // 移出
    handleMouseLeave(item) {
      this.hoverType[item] = 0
    },
    clickChangePage(index) {
      // this.$refs.mySwiper.slideTo(index);
      this.swiper.slideTo(index);
      console.log(this.$refs.mySwiper)
    },
    onSwiper(swiper) {
      this.swiper = swiper
      console.log('哈哈哈哈哈',swiper);
    },
    onSlideChange(swiper) {
      this.swiper = swiper
      this.curIndex = swiper.activeIndex
      // console.log('slide change',swiper);
    },
    changeTypeTitleName() {
        if (this.contType == "f") {
          document.title = "產品服務";
        }else if(this.contType == 'e'){
          document.title = 'Products and services'
          // this.swiperOption.slidesPerView = 1.4
        } else {
          document.title = "产品服务";
        }
    }
  },

  mounted() {
    this.bodyW = document.body.clientWidth;
    this.bodyY = document.body.clientHeight;
    var that = this;
    this.contType = window.localStorage.getItem("language");
    that.changeTypeTitleName()
    window.addEventListener("setItemEvent", function (e) {
      if (e.key == "language") {
        that.contType = e.newValue;
        that.changeTypeTitleName()
      }
      
    });
    var wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 40,
      mobile: true,
      live: true,
    });
    wow.init();

  },
};
</script>


<style src="../assets/css/ProductService-pc.css"  scoped>

</style>
<style src="../assets/css/ProductService-phone.css"  scoped>

</style>

<!-- <style lang="less" scoped>

@import '../assets/css/ProductService-pc.css';
@import '../assets/css/ProductService-phone.css';

</style> -->


